var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-links-block w-100"},[_c('div',{staticClass:"m-auto privacy-policy",on:{"click":_vm.openPrivacyPolicy}},[_vm._v(_vm._s(_vm.$t('shared.external_links.privacy_policy')))])])}
var staticRenderFns = []

export { render, staticRenderFns }